export const suodlucivanje_r_vijece= {
    templateId: 77,
    category: 17,
    templateTitle: 'Suodlučivanje s radničkim vijećem/sindikalnim povjerenikom prije donošenja odluke',
    templateDescription: `<p>Određene odluke propisane Zakonom o radu Poslodavac može donijeti samo uz prethodnu suglasnost radničkog vijeća odnosno sindikalnog povjernika.</p>`,
    description: `
    <h5>OPIS I SVRHA DOKUMENTA</h5>
    <p><strong>Za početak je važno reći da ukoliko kod poslodavca nije utemeljeno radničko vijeće, no postoji imenovan sindikalni povjerenik, da isti preuzima sva prava i obveze radničkog vijeća propisane Zakonom o radu.</strong> </p>
    <p>Sukladno Zakonu o radu, poslodavac može samo uz prethodnu suglasnost radničkog vijeća/sindikalnog povjereniku donijeti odluku o:</p>
    <p> 1) otkazu članu radničkog vijeća, osim ako se odlukom rješava o pravima radnika koji ujedno je i sindikalni povjerenik koji uživa zaštitu iz članka 188. Zakona o radu,</p>
    <p> 2) otkazu kandidatu za člana radničkog vijeća koji nije izabran, u razdoblju od tri mjeseca nakon utvrđenih konačnih rezultata izbora,</p>
    <p> 3) otkazu radniku kod kojeg je zbog ozljede na radu ili profesionalne bolesti došlo do smanjenja radne sposobnosti uz preostalu radnu sposobnosti ili do smanjenja radne sposobnosti uz djelomični gubitak radne sposobnosti, odnosno otkazu radniku osobi s invaliditetom, </p>
    <p> 4) otkazu radniku s navršenih šezdeset godina odnosno starijem od šezdeset godina, </p>
    <p> 5) otkazu predstavniku radnika u organu poslodavca, </p>
    <p> 6) uvrštavanju osoba iz članka 34. stavka 1. ovoga Zakona u kolektivni višak radnika, osim u slučaju kada je poslodavac u skladu s posebnim propisom pokrenuo, odnosno provodi postupak likvidacije, </p>
    <p> 7) prikupljanju, obrađivanju, korištenju i dostavljanju trećim osobama podataka o radniku, </p>
    <p> 8) <a class="local-link" href="/contract?template=231">imenovanju</a> osobe koja je ovlaštena nadzirati da li se osobni podaci radnika prikupljaju, obrađuju, koriste i dostavljaju trećim osobama u skladu s odredbama ovoga Zakona. </p>
    <p>Ako se radničko vijeće u roku od osam dana ne izjasni o davanju ili uskrati suglasnosti, smatra se da je suglasno s odlukom poslodavca.</p>
    <p>Ako radničko vijeće uskrati suglasnost, uskrata mora biti pisano obrazložena. </p>
    <p><strong>Važno je naglasiti da poslodavac vezan očitovanjem radničkog vijeća/sindikata te svoju odluku ne može donijeti ako navedeni protive istoj, no poslodavac može u roku od petnaest dana od dana dostave izjave o uskrati suglasnosti tražiti da tu suglasnost nadomjesti sudska ili arbitražna odluka. </strong> </p>
    <p>Primjerak prethodno opisane obavijesti nalazi se u nastavku.</p>
    <h5>PRAVNA OSNOVA</h5>
    <p>Zakon o radu.</p>
  `,
  sides: [
    {
      prefix: "",
      signature: 'Za Poslodavca:',
      inputs: [{
        type: "input",
        required: true,
        placeholder: "R. vijeće / Sindikalni povj.",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ime i prezime",
        help: 'Ime i prezime predsjednika radničkog vijeća ili sindikalnog povjerenika',
      },
    ],
      suffix: "",
    }
  ],

  headline: "",
  
    title: '\r\n\r\nPREDMET: Obavijest Poslodavca prema čl. 151. Zakona o radu',
    noArticleNumbers: true,
    noArticleTitle: true,
    suffix: ' ',

    articles: [
            
                {
                    title: '',
                    mandatory: false,
                    exampleContent: true,
                    dummy: true,
                    statements: [
                        {
                            type: 'text',
                            mandatory: true,
                            editable: true,
                            content: 'PRIMJER OBAVIJESTI RADNIČKOM VIJEĆU ODNOSNO SINDIKALNOM POVJERENIKU KOD DONOŠENJA ODLUKE O IMENOVANJU OSOBE OVLAŠTENE ZA NADZOR U PRIKUPLJANJU, OBRADI I KORIŠTENJU OSOBNIH PODATAKA RADNIKA. \r\n\r\nPoštovani,\r\n\r\novim dopisom Vas obavještavamo o namjeri donošenja odluke o imenovanju osobe ovlaštene za nadzor u prikupljanju, obradi i korištenju osobnih podataka radnika. \r\nU tom smislu dostavljamo Vam prijedlog odluke o imenovanju osobe ovlaštene za nadzor u prikupljanju, obradi i korištenju osobnih podataka radnika radi očitovanja, sukladno Zakonu o radu.\r\nUzimajući maksimalno u obzir interese i obveze te prava, kako poslodavca tako i radnika, molimo da proučite predmetnu Odluku koju Vam dostavljamo uz ovu Obavijest. \r\nPredlažemo da na istu date suglasnost, sukladno Zakonu o radu.\r\nU slučaju da se ne izjasnite u zakonskom roku od 8 dana o davanju ili uskrati suglasnosti, smatra se da ste suglasni s koja se nalazi u privitku ove Obavijesti.\r\n\r\nS poštovanjem.',
                            help: 'Ova obavijest se odnosi na primjer suodlučivanja kod odluke o imenovanju osobe ovlaštene za nadzor u prikupljanju, obradi i korištenju osobnih podataka. Navedeni prijedlog trebate brisati ili izmijeniti, ovisno o slučaju koji se pojavljuje kod vas.',
                            value: '',
                        }],
                },
                {
                    mandatory: true,
                    static: true,
                    type: 2, // date and place
                    statements: [
                      {
                        type: "input",
                        mandatory: true,
                        parts: [
                          {
                            type: "text",
                            content: "U"
                          },
                          {
                            type: "input",
                            value: "",
                            placeholder: "Upišite mjesto.",
                            required: true,
                          },
                          {
                            type: "text",
                            content: ", dana"
                          },
                          {
                            type: "date",
                            value: new Date(),
                            required: true
                          },
                          {
                            type: "text",
                            content: "godine."
                          }
                        ]
                      },
                    ]
                  },
                {
                    mandatory: true,
                    static: true,
                    type: 3,  // signatures
                    statements: [],
                },
                {
                    static: true,
                    mandatory: false,
                    type: 4, 
                    statements: [
                      {
                        type: 'text',
                        mandatory: true,
                        editable: true,
                        content: 'Dostaviti:\r\n1) Sindikalnom povjerniku / radničkom vijeću Poslodavca \r\n2) Kadrovska služba',
                        help: 'Po želji, slobodno dopišite kome želite dostaviti dopis odnosno izmijenite/obrišite predložene unose.'
                      }
                    ]
                  },
            ],
};












// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/77_suodlucivanje_r_vijece.ts